import styled from 'styled-components';
import BodyCopy from '../../../../../atoms/BodyCopy';

export const PromotionCheckboxContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const PromotionCheckboxWrapper = styled.div`
  display: flex;
  gap: 9px;
  align-items: center;
  background: unset;
`;

export const PromotionCheckboxPrice = styled.div`
  padding: 4px 8px;
  border-radius: 6px;
  background: #26762c;
  color: ${(props) => props.theme.colors.WHITE};
  max-height: 27px;
`;

export const PromotionCheckboxLabel = styled(BodyCopy)`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 12px;
  }
`;
